import { FC } from "react";
import { Badge } from "shared/components/Spor";

type TrainBadgesProps = {
  trainIds: string[];
};

export const TrainBadges: FC<TrainBadgesProps> = ({ trainIds }) => (
  <>
    {trainIds.map((it) => (
      <Badge key={it} data-color="neutral">
        {it}
      </Badge>
    ))}
  </>
);
